import axios from 'axios';
import { BASE_API } from '../shared/constants/app';
import store from '../redux/store';
import { logoutSuccess } from '../redux/reducers/auth';

const Http = axios.create({
    baseURL: BASE_API,
});

Http.interceptors.request.use(
    async (config) => {
        const state = store.getState();
        const auth = state?.auth;
        const login = auth?.login;

        if (login.loggedIn) {
            const token = login?.token;
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    async (error) => {
        return Promise.reject(error);
    },
);

Http.interceptors.response.use(
    async (response) => response,
    async (error) => {
        if (error.response && error.response.status === 403) {
            window.location.href = '/forbidden';
        } else if (error.response.status === 401) {
            store.dispatch(logoutSuccess());
            window.location.href = '/';
        }
        return Promise.reject(error);
    },
);

export default Http;
